import React from 'react'
import Cytof from './Cytof'
// import { IconAlternate } from 'components/molecules';


export const services = [
    {
      icon: 'fas fa-layer-group',
      title: 'High-data density per sample volume ',
      subtitle:
        ' Discover differences in heterogeneous populations with single-cell accuracy',
    },
    {
      icon: 'fas fa-dollar-sign',
      title: 'Single-tube cytometry ',
      subtitle:
        ' Measure 50-plus parameters per cell. ',
    },
    {
      icon: 'fas fa-dna',
      title: 'Batch effect mitigation ',
      subtitle:
        "Sample barcoding and tools for data normalization reduce variability. ",
    },
    {
      icon: 'fas fa-dna',
      title: 'Multi-site reproducibility ',
      subtitle:
        "White paper on PBMC and whole blood multi-site study data ",
    },
    {
        icon: 'fas fa-dna',
        title: 'Built-in biosafety ',
        subtitle:
          "Sample fixation neutralizes viral pathogens for safe handling. ",
      },
      {
        icon: 'fas fa-dna',
        title: 'Flexible panel design with robust reagents  ',
        subtitle:
          " 28 pre-designed panel kits to choose from or label antibodies of your choice with any of 42 isotopic metals ",
      },
      {
        icon: 'fas fa-dna',
        title: 'Same antibody clones and workflow as flow cytometry ',
        subtitle:
          " Over 750 antibody conjugates with familiar antibody clones ",
      },
      {
        icon: 'fas fa-dna',
        title: 'End-to-end workflow solutions ',
        subtitle:
          " Maxpar® Direct™ Immune Profiling System and Maxpar Direct Expansion Panels enable robust immune profiling studies.",
      },
  ];

function Cytofpart() {
    return (
        <div>
           <Cytof data = {services}/> 
        </div>
    )
}

export default Cytofpart
